<app-spinner *ngIf="loading$ | async"></app-spinner>
<router-outlet></router-outlet>
